<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>

      <div class="formTableItem">
        <p class="label">项目名称</p>
        <div style="width: 120px">
          <selectItems
            :name="searchItem.groupName"
            @update:name="searchItem.groupName = $event"
            :id="searchItem.groupId"
            @update:id="searchItem.groupId = $event"
            clearable
          ></selectItems>
        </div>
      </div>

      <div class="formTableItem">
        <p class="label">所属部门</p>
        <selectGroup
          :name="searchItem.deptName"
          @update:name="searchItem.deptName = $event"
          :id="searchItem.deptId"
          @update:id="searchItem.deptId = $event"
          clearable
        >
        </selectGroup>
      </div>

      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="open(row)">作业轨迹</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal v-model="openForm" title="查看作业轨迹" footer-hide fullscreen>
      <locusMap
        ref="gmap"
        @curentPoint="reCurentPoint"
        :isNavg="true"
        type="car"
      ></locusMap>
      <showHide right="10px" v-if="$store.state.control">
        <now-data
          :data="otherData"
          :curentPoint="curentPoint"
          @changeSpeed="reChangeSpeed"
          @parentFn="rePlayStop"
          @changeSlider="reChangeSlider"
          @dark="reDark"
          @jiashi="reJiashi"
          jiandan
          ref="slider"
        ></now-data>
      </showHide>
      <div id="workLineBtn">
        <Button @click="showHideLine" type="primary">{{isWorkLine?'隐藏规划线路':'显示规划线路'}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import locusMap from "../map/locusMap.vue";
import nowData from "../locus/nowData.vue";
export default {
  components: { locusMap, nowData },
  data() {
    return {
      openForm: false,
      curentPoint: 0,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "所属部门",
          key: "deptName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "线路名称",
          key: "lineName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "路段标签",
          key: "lable",
          minWidth: 150,
          maxWidth: 200,
        },
        {
          title: "要求作业里程",
          key: "jobMileage",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "实际作业里程",
          key: "jobMileageReal",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "排班开始时间",
          key: "startTime",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "排班结束时间",
          key: "endTime",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "实际开始时间",
          key: "startTimeReal",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTimeReal, "hhmm"));
          },
        },
        {
          title: "实际结束时间",
          key: "endTimeReal",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTimeReal, "hhmm"));
          },
        },
        {
          title: "作业完成率/%",
          key: "finishPercent",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "作业日期",
          key: "jobDate",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.jobDate, "yymmdd"));
          },
        },
        {
          title: "状态",
          key: "status",
          minWidth: 80,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("workStatus." + data.row.status));
          },
        },
        {
          title: "负责人",
          key: "manager",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "联系电话",
          key: "tel",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "查看",
          slot: "action",
          width: 90,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        keyWork: "",
        groupName: "",
        groupId: "",
        deptName: "",
        deptId: "",
        endDate: "",
        startDate: "",
        pageNumber: "",
        pageNumber: 1,
        pageSize: 50,
      },
      otherData: [],
      speed: 0,
      workData: [],
      isWorkLine: false,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.mwm + "/scheduleHistory/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(data);
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    reset() {},
    open(row) {
      this.openForm = true;
      this.getPlyLocus(row);
      this.getWorkLine(row);
    },
    getPlyLocus(x) {
      let params = {
        deviceNo: x.deviceNo,
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: x.endTimeReal,
        startTime: x.startTimeReal,
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.lbs + "/locus/getPlyLocus",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.otherData = data;
        var lnglat = [];
        console.log(res);
        for (let i = 0; i < data.length; i++) {
          lnglat.push([data[i].returnX, data[i].returnY]);
          data[i].tms = data[i].gpsTime / 1000;
          data[i].locateLng = data[i].returnX;
          data[i].locateLat = data[i].returnY;
          data[i].gpsTime = this.utils.time(data[i].gpsTime);
          data[i].reportTime = this.utils.time(data[i].reportTime);
          data[i].startParkTime = this.utils.time(data[i].startParkTime);
          data[i].endParkTime = this.utils.time(data[i].endParkTime);
        }
        this.$store.state.control = true;
        this.$refs.gmap.loadUi(lnglat, data); //渲染轨迹
      });
    },
    reChangeSpeed(v) {
      this.$refs.gmap.reSpeed(v);
    },
    //拖动滑块后，接收传过来得值，去调用地图组件函数
    reChangeSlider(v) {
      this.$refs.gmap.reSlider(v);
    },
    //接收子组件的播放暂停
    rePlayStop(t) {
      this.$refs.gmap.play(t);
    },
    //接收白天黑夜模式
    reDark() {
      this.$refs.gmap.dark();
    },
    //接收驾驶模式
    reJiashi(v) {
      this.isDriver = v;
      if (v) {
        setTimeout(() => {
          this.$refs.driver.setWidth(this.otherData);
        }, 500);
      }
    },
    reCurentPoint(t, length) {
      this.$refs.slider.changeCurentPoint(t, length);
      this.curentPoint = t;
    },
    getWorkLine(x) {
      this.isJiuPian = false;
      this.isFisrtJiupian = true;
      let params = {
        deviceNo: x.deviceNo,
        endDate: x.endTimeReal,
        startDate: x.startTimeReal,
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.mwm + "/schedule/carLine",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.workData = data;
        // this.$refs.locusDraw.open();
        this.isWorkLine = true;
        this.showHideLine();
      });
    },
    showHideLine() {
      this.isWorkLine = !this.isWorkLine;
      if (this.isWorkLine) {
        this.$refs.gmap.showWorksLines(this.workData);
      } else {
        this.$refs.gmap.showWorksLines([]);
      }
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
#workLineBtn{
  position: absolute;
  z-index: 2;
  bottom: 10px;
  right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/carsys/zycx.vue